export default (state, action) => ({
  ...state,
  windowsWithInvalidConfigurationsModalOpen:
  action.payload.windowsWithInvalidConfigurationsModalOpen,
  windowsWithInvalidConfigurations:
  action.payload.windowsWithInvalidConfigurations,
});
